import { render } from "./selectPlaceComponent.vue?vue&type=template&id=b3297b94"
import script from "./selectPlaceComponent.vue?vue&type=script&lang=js"
export * from "./selectPlaceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__